module.exports = __webpack_public_path__ + "static/media/4.68b9d467.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_138/images/九宫格选中态/4.png
// module id = 1276
// module chunks = 0